import { render, staticRenderFns } from "./SaleLabel.vue?vue&type=template&id=2100a838&scoped=true&lang=pug&"
import script from "./SaleLabel.vue?vue&type=script&lang=js&"
export * from "./SaleLabel.vue?vue&type=script&lang=js&"
import style0 from "./SaleLabel.vue?vue&type=style&index=0&id=2100a838&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2100a838",
  null
  
)

export default component.exports